// extracted by mini-css-extract-plugin
export default {"brand_small_slider":"style_brand_small_slider__OT+Fy","brand_small_banners_item":"style_brand_small_banners_item__hQnYb","slider_image":"style_slider_image__q8Jsi"};